// Mock data for system configuration
import { SystemConfig } from './types';

export const mockSystemConfig: SystemConfig = {
  id: 'system-config-1',
  districtId: 'district-1',
  securitySettings: {
    passwordPolicy: {
      minLength: 8,
      requireUppercase: true,
      requireLowercase: true,
      requireNumbers: true,
      requireSpecialChars: true,
      expiryDays: 90
    },
    sessionTimeout: 30, // minutes
    maxLoginAttempts: 5,
    lockoutDuration: 15 // minutes
  },
  skipAndMoveToGamePolicy: {
    enabled: true,
    districtDefault: true,
    schoolOverrides: {
      'school-1': true,
      'school-2': false,
      'school-3': true
    }
  },
  learningPhaseProgression: {
    districtDefault: {
      id: 'progression-rule-default',
      name: 'District Default',
      videoCompletionRequired: true,
      minVideoCompletionPercentage: 90,
      practiceQuestionsRequired: true,
      minPracticeQuestions: 5,
      minAccuracyPercentage: 80,
      isDefault: true
    },
    schoolOverrides: {
      'school-2': {
        id: 'progression-rule-school-2',
        name: 'Advanced School Override',
        videoCompletionRequired: true,
        minVideoCompletionPercentage: 100,
        practiceQuestionsRequired: true,
        minPracticeQuestions: 8,
        minAccuracyPercentage: 85,
        isDefault: false
      }
    }
  },
  integrationSettings: {
    lmsConnection: {
      provider: 'Canvas',
      apiEndpoint: 'https://canvas.instructure.com/api/v1',
      syncFrequency: 'daily',
      lastSynced: '2025-05-23T03:00:00'
    },
    ssoSettings: {
      provider: 'Google',
      clientId: 'google-oauth-client-id',
      enabled: true
    },
    csvImport: {
      automaticImport: true,
      importTime: '03:00', // 3 AM
      notifyOnFailure: true,
      notificationEmail: 'admin@riversideunified.org'
    }
  },
  featureToggles: {
    smartDifficulty: true,
    leaderboards: true,
    achievements: true,
    parentPortal: false,
    aiAssistant: true
  },
  concurrentAccess: {
    defaultTimeout: 30, // minutes
    requireJustification: true,
    logAllActions: true
  },
  updatedAt: '2025-05-20T14:30:00'
};
